/* eslint-disable node/no-unsupported-features */
export const CHANGE_THEME = 'CHANGE_THEME';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const RECEIVE_LOGIN = 'RECEIVE_LOGIN';
export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const ERROR_LOGIN_CONNECTION = 'ERROR_LOGIN_CONNECTION';
export const ERROR_LOGIN_LOGIN = 'ERROR_LOGIN_LOGIN';
export const RESET_ERROR_LOGIN = 'RESET_ERROR_LOGIN';

export const REQUEST_TELOMERE = 'REQUEST_TELOMERE';
export const RECEIVE_TELOMERE = 'RECEIVE_TELOMERE';
export const ERROR_TELOMERE = 'ERROR_TELOMERE';
export const RESET_ERROR_TELOMERE = 'RESET_ERROR_TELOMERE';

export const REQUEST_POST = 'REQUEST_POST';
export const RECEIVE_POST = 'RECEIVE_POST';
export const ERROR_POST = 'ERROR_POST';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js